import React from "react";
import PropTypes from "prop-types";
import withTranslation from "../translation";
import CountrySelectorButton from "../CountrySelectorButton";
import { ANALYTICS_POSITION_HEADER } from "../../../helpers/events";
import styles from "./MiscBar.css";
import { getMarketplaceUrl } from "../../helpers/externalLinks";
import { withParams } from "../../../helpers/queryString";
import classnames from "classnames/bind";
const cx = classnames.bind(styles);

const marketplaceUrl = () =>
  withParams(getMarketplaceUrl(), {
    ctaref: "Global nav"
  });

const MiscBar = ({
  formatTranslation,
  defaultStoreUrl,
  headerTopBarHidden
}) => (
  <div
    className={cx(styles.container, {
      [styles.hidden]: headerTopBarHidden
    })}
    data-testid="topbar"
  >
    <div className={styles.body}>
      <ul className={styles.navigation}>
        <li>
          <a
            href={`${marketplaceUrl()}|emf82v1`}
            data-testid="marketplace"
            className={styles.asosFocus}
          >
            {formatTranslation("miscbar_marketplace")}
          </a>
        </li>
        <li>
          <a
            href={defaultStoreUrl.concat(formatTranslation("miscbar_helplink"))}
            data-testid="help"
            className={styles.asosFocus}
          >
            {formatTranslation("miscbar_help")}
          </a>
        </li>
        <li>
          <CountrySelectorButton position={ANALYTICS_POSITION_HEADER} />
        </li>
      </ul>
    </div>
  </div>
);

MiscBar.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  defaultStoreUrl: PropTypes.string.isRequired,
  headerTopBarHidden: PropTypes.bool
};

export default withTranslation(MiscBar);
